import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TipoScontrino } from '@app/shared/models/assistenza';
import { UtilityService } from '@app/shared/services/utility.service';

@Component({
  selector: 'ser-tipo-scontrino-select',
  templateUrl: './tipo-scontrino-select.component.html',
  styleUrl: './tipo-scontrino-select.component.scss'
})
export class TipoScontrinoSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() label: string = "assistenze.fields.tipoScontrino";
  @Input() readonly: boolean = false;

  tipi: IS1InputSelectItem[];

  constructor(private utils: UtilityService) {
    this.tipi = this.utils.getInputSelectFromEnum(TipoScontrino);
  }

}
